var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160694",
    "data-name": "Group 160694",
    transform: "translate(-503.5 -263.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160614",
    "data-name": "Group 160614",
    transform: "translate(504 264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1149",
    "data-name": "Rectangle 1149",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "#ffecd4",
    stroke: "#787f88",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1150",
    "data-name": "Rectangle 1150",
    width: 16.159,
    height: 16.691,
    rx: 2,
    transform: "translate(0.9 0.679)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3266",
    "data-name": "Group 3266",
    transform: "translate(4.704 3.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M10.331,6.065l.466-.941a.288.288,0,0,1,.515,0l1.129,2.283a.278.278,0,0,0,.213.155l2.52.368a.286.286,0,0,1,.155.491L13.505,10.2a.293.293,0,0,0-.082.254l.434,2.5a.286.286,0,0,1-.417.3l-2.25-1.186a.312.312,0,0,0-.27,0L8.67,13.257a.286.286,0,0,1-.417-.3l.434-2.5A.293.293,0,0,0,8.6,10.2L6.78,8.422",
    transform: "translate(-6.78 -4.965)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y1: 0.311,
    x2: 0.155,
    transform: "translate(3.314 1.264)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986-2",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1151",
    "data-name": "Rectangle 1151",
    width: 11.135,
    height: 1.219,
    rx: 0.61,
    transform: "translate(3.404 13.876)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 0.466,
    cy: 0.466,
    r: 0.466,
    transform: "translate(6.324 5.523)",
    fill: "#165cf3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesDarkIcon);
export default __webpack_public_path__ + "static/media/features-dark-icon.b8882ab88f5fcc2f4fb2df4126f69173.svg";
export { ForwardRef as ReactComponent };